// eslint-disable-next-line no-restricted-imports
import { useFlags } from 'launchdarkly-react-client-sdk';

import type { MeterLDFlags } from '../feature_flags';
import { LOCAL_LD_FLAG_VALUES } from '../feature_flags';
import { getRealm, Realm } from '../utils/realm';

/**
 * @deprecated Please use `<HasAccess>` or `useAccessLevelForUser` instead unless you're sure what
 * you're doing.
 */
export function useFeatureFlags(): MeterLDFlags {
  const flags = useFlags() as MeterLDFlags;
  const realm = getRealm();

  if (realm === Realm.LOCAL) {
    return LOCAL_LD_FLAG_VALUES;
  }

  return flags;
}
